<template>
  <div :class="BOX">
    <!-- Travel and Late are painted with a repeating chevron rather than a
         fill, so the artwork is tiled to the swatch's width the way the board
         tiles it across a trip. -->
    <span v-if="row.swatch === 'pattern'" class="flex h-full">
      <component :is="patternArt" class="h-full" />
      <component :is="patternArt" class="h-full" />
    </span>
    <component
      :is="row.icon"
      v-else-if="row.swatch === 'icon'"
      class="h-5 w-5 text-gray-700"
    />
    <span
      v-else
      class="block h-full w-full rounded"
      :class="row.swatch === 'dashed' ? 'border-2 border-dashed' : ''"
      :style="fillStyle"
    ></span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import LateArt from "@/images/late_travel_path.svg?component";
import TravelArt from "@/images/travel_path.svg?component";
import { ScheduleLegendRow } from "./scheduleLegendRows";

// One swatch of the schedule key, drawn the way the board draws that status.
// Colours arrive resolved rather than looked up here: the board is the single
// source of what a status is painted, and this component only renders it.
const props = defineProps<{
  row: ScheduleLegendRow;
  // The status colour the board paints. Undefined until the tenant's
  // customizations land, which is why the fill is omitted rather than set to a
  // transparent value that would read as a real colour.
  color?: string;
  // The lightened fill the board uses behind a dashed event.
  backgroundColor?: string;
}>();

const BOX =
  "flex h-6 w-[70px] shrink-0 items-center justify-center overflow-hidden rounded";

const patternArt = computed(() =>
  props.row.pattern === "late" ? LateArt : TravelArt
);

// A dashed row is outlined in the status colour over the lightened fill, the
// same pairing the board uses; a solid row is the status colour itself.
const fillStyle = computed(() => {
  if (!props.color) return {};
  if (props.row.swatch === "dashed") {
    return { borderColor: props.color, background: props.backgroundColor };
  }
  return { background: props.color };
});
</script>
